export default __webpack_public_path__ + "static/media/guto.34e13ba5.jpg";